import { useDispatch as useReduxDispatch } from 'react-redux';

import { AppDispatch } from '@glass/web/modules/redux/types';

const useDispatch = useReduxDispatch as AppDispatch;

export default useDispatch;
